import { render } from "./ApplicantSelectTest.vue?vue&type=template&id=5feacba8&scoped=true"
import script from "./ApplicantSelectTest.vue?vue&type=script&lang=ts"
export * from "./ApplicantSelectTest.vue?vue&type=script&lang=ts"

import "./ApplicantSelectTest.vue?vue&type=style&index=0&id=5feacba8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5feacba8"
/* custom blocks */
import block0 from "./ApplicantSelectTest.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script